import appBulkInvoiceItemTypesUploads from "../../views/appSettings/bulkInvoiceItemTypesUploadsView.html";
import constants from "../../core/constants";
import { getState } from "../../core/utils";

function urlsConfig($stateProvider) {
  "ngInject";

  const base = "bulk-invoice-item-types-uploads";
  const params = ["page', 'limit"];

  $stateProvider.state("bulkinvoiceitemtypesuploads", {
    url: getState(base, params),
    parent: "app",
    views: {
      view: {
        template: appBulkInvoiceItemTypesUploads,
      },
    },
    reloadOnSearch: false,
    data: { title: "BulkInvoiceItemTypesUploads" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/bulkInvoiceItemTypesUploads/bulkInvoiceItemTypesUploads.urls.js